<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button
        icon="chevron-back"
        defaultHref="tabs/jobs"
      ></ion-back-button>
    </ion-buttons>
    <ion-title>Last Minute job</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content *ngIf="job">
  <div class="notification ion-margin">
    <ion-icon name="checkmark-circle"></ion-icon>
    <div class="message">
      <p>Job Booked</p>
      <p class="text-normal">{{job?.workerFields?.match?.amount}} per Hour</p>
    </div>
  </div>
  <div class="mable-section">
    <div class="body-normal-16 sub-section ion-margin-horizontal">
      A service agreement has been automatically created. Submit support hours after the job finishes.
    </div>
    <div class="body-normal-16 sub-section">
      <p class="ion-margin-horizontal">
        {{job?.client?.truncatedName}} has accepted your offer and will send through the address shortly.
      </p>
      <app-cancellation-policy buttonColor="purple-400"></app-cancellation-policy>
    </div>
    <ion-item
      lines="none"
      class="default"
    >
      <ion-grid class="no-padding">
        <ion-row>
          <ion-col [size]="job?.workerFields?.conversation?.sendbirdChannelDetail?.channelUrl ? '6' : '12'">
            <mable-button
              category="outline"
              expand="block"
              (onClick)="cancelBooking()"
              class="ion-no-margin"
            >
              Cancel Booking
            </mable-button>
          </ion-col>
          <ion-col
            size="6"
            *ngIf="job?.workerFields?.conversation?.sendbirdChannelDetail?.channelUrl"
          >
            <!--TODO: Fix alignment issue-->
            <app-message-button
              [buttonText]="'Message '+job?.client?.truncatedName"
              [userId]="job?.client?.id"
              [channelUrl]="job?.workerFields?.conversation?.sendbirdChannelDetail?.channelUrl"
            >
            </app-message-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-item>
  </div>
  <div class="mable-section">
    <app-flex-job-summary
      [job]="job"
      bgColor="white-0"
    ></app-flex-job-summary>
  </div>
</ion-content>
